define('app/views/checkout_guest_register_form',['app/setup'], function(takhfifan) {
  takhfifan.checkoutGuestRegisterView= Backbone.View.extend({
    events: {
      'change #signMeIn-guest': 'showGuestForm',
      'change #signMeIn': 'showRegisterForm'
    },

    initialize: function(options){

    },
    showGuestForm: function(e){
      e.preventDefault();
      $("#signMeIn-guest").prop('checked', false);
      this.$el.removeClass('guest-view').addClass('register-view');
    },
    showRegisterForm: function(e){
      e.preventDefault();
      $("#signMeIn").prop('checked', true);
      this.$el.removeClass('register-view').addClass('guest-view');
    }
  });
});

